import React from 'react';
import { getMonthDayYear } from '@domain-group/fe-allhomes-library';
import { Badge } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './editorial-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var EditorialCard = _ref => {
  var article = _ref.article,
    _ref$useIndexHeadline = _ref.useIndexHeadline,
    useIndexHeadline = _ref$useIndexHeadline === void 0 ? false : _ref$useIndexHeadline,
    _ref$imagePosition = _ref.imagePosition,
    imagePosition = _ref$imagePosition === void 0 ? 'left' : _ref$imagePosition,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick,
    _ref$fixedHeight = _ref.fixedHeight,
    fixedHeight = _ref$fixedHeight === void 0 ? false : _ref$fixedHeight,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '' : _ref$target,
    _ref$rel = _ref.rel,
    rel = _ref$rel === void 0 ? '' : _ref$rel,
    _ref$headingTag = _ref.headingTag,
    headingTag = _ref$headingTag === void 0 ? 'h3' : _ref$headingTag;
  var _article$image = article.image,
    image = _article$image === void 0 ? '' : _article$image,
    _article$url = article.url,
    url = _article$url === void 0 ? '' : _article$url,
    _article$title = article.title,
    title = _article$title === void 0 ? null : _article$title,
    _article$indexHeadlin = article.indexHeadline,
    indexHeadline = _article$indexHeadlin === void 0 ? null : _article$indexHeadlin,
    _article$tags = article.tags,
    tags = _article$tags === void 0 ? [] : _article$tags,
    _article$author = article.author,
    author = _article$author === void 0 ? '' : _article$author,
    _article$date = article.date,
    date = _article$date === void 0 ? '' : _article$date;
  var HeadingTag = headingTag;
  var leftImage = imagePosition === 'left';
  var articleTitle = useIndexHeadline ? indexHeadline : title;
  return ___EmotionJSX("div", {
    css: styles.articleCard
  }, image && !leftImage && ___EmotionJSX("div", {
    css: styles.topImageContainer
  }, ___EmotionJSX("a", {
    href: url,
    css: styles.link,
    target: target,
    rel: rel,
    onClick: onClick,
    "aria-label": title || ''
  }, ___EmotionJSX("img", {
    src: image,
    alt: ""
  }))), ___EmotionJSX("div", {
    css: styles.content
  }, image && leftImage && ___EmotionJSX("div", {
    css: styles.leftImageContainer
  }, ___EmotionJSX("a", {
    href: url,
    css: styles.link,
    target: target,
    rel: rel,
    onClick: onClick,
    "aria-label": title || ''
  }, ___EmotionJSX("img", {
    src: image,
    alt: ""
  }))), ___EmotionJSX("div", {
    css: styles.middle
  }, articleTitle && ___EmotionJSX("a", {
    href: url,
    css: styles.link,
    target: target,
    rel: rel,
    onClick: onClick
  }, ___EmotionJSX(HeadingTag, {
    css: styles.heading,
    className: "title"
  }, articleTitle)), ___EmotionJSX("div", {
    css: styles.authorDate
  }, author && ___EmotionJSX("div", {
    css: styles.author
  }, author), date && ___EmotionJSX("div", {
    css: styles.date
  }, getMonthDayYear(date))), ___EmotionJSX("div", {
    css: styles.tags
  }, tags.filter(Boolean).map(item => ___EmotionJSX("a", {
    href: item.url || '#',
    css: styles.tag
  }, ___EmotionJSX(Badge, {
    key: item.slug,
    label: item.label,
    css: styles.tagLabel,
    className: "tagLabel"
  }))), fixedHeight && tags.filter(Boolean).length === 0 ? ___EmotionJSX("div", {
    css: styles.tags
  }, "\xA0") : null))));
};
export default EditorialCard;